import {doc, setDoc, collection, query, updateDoc, getDocs, where, deleteDoc, getDoc, serverTimestamp, Timestamp} from "firebase/firestore";
import {db} from "../components/firebase";
import { buildFullName, resolveNameParts } from "../utils/nameUtils";

export const ActualizarFirma = async(cifrado, id) =>{
    const iddoc = id
    const docRef = doc(db, "Ordenes", iddoc)
    await updateDoc(docRef, {Firma: cifrado})
}       

export const AddOrders = async (ord, docRef) => {
  try {
    await setDoc(docRef, ord);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error al agregar orden:", error);
    return { success: false, error };
  }
};

export const GetCategorias  = async() =>{
    let cat = []
    const querySnapshot = await getDocs(collection(db, "ListaPrecios"));
    querySnapshot.forEach((doc) => {
        const d = doc.data();
        const i = {'Grupo': doc.id};
        cat.push({...d, ...i});
    });
    return cat
}

export const GetTalleres = async() =>{
    let talleres = []
    const docRef = query(collection(db, 'Usuarios'));
    const querySnapshot = await getDocs(docRef)
    querySnapshot.forEach((doc) => { if (!doc.data().Taller || !doc.data().Taller.startsWith('Goldmund')) talleres.push(doc.data()) });
        return talleres
}

export const GetOrdenesActivas = async(useruid) =>{
    const ref = query(
        collection(db, 'PreOrdenes'),
        where('uid', "==", useruid),
    );
    let ordenes = []
    try {
        const querySnapshot = await getDocs(ref);
        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {ordenes.push({ id: doc.id, ...doc.data() });})
            return ordenes;
        } else {
            console.log(`Documento no encontrado donde uid == ${useruid}`);
            return [];
        }
    } catch (error) {
        console.error("Error al ejecutar la consulta:", error);
        throw error;
    }
}

export const BorrarPreOrden = async (iddoc, uid) => {
    const q = query(
        collection(db, 'PreOrdenes'),
        where('iddoc', '==', iddoc),
        where('uid', '==', uid));

    try {
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            console.log(`No se encontro el docuemento con iddoc: ${iddoc} para UID: ${uid}.`);
            return false;
        }
        const documentSnapshot = querySnapshot.docs[0];
        const docId = documentSnapshot.id;
        const docRef = doc(db, 'PreOrdenes', docId);
        await deleteDoc(docRef);
        console.log(`Documento con ID ${docId} (iddoc: ${iddoc}) eliminado con éxito.`);
        return true;
    } catch (error) {
        console.error("Error al buscar o eliminar el documento:", error);
        throw error;
    }
}

const buildProductId = () =>
  `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const parseDateOnlyToTimestamp = (value) => {
  const raw = String(value || "").trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const utcDate = new Date(Date.UTC(year, month - 1, day));
  const sameDate =
    utcDate.getUTCFullYear() === year &&
    utcDate.getUTCMonth() + 1 === month &&
    utcDate.getUTCDate() === day;

  if (!sameDate) return null;
  return Timestamp.fromDate(utcDate);
};

const normalizeFechaCompraToTimestamp = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value;
  if (value instanceof Date) return Timestamp.fromDate(value);
  return parseDateOnlyToTimestamp(value);
};

const formatDateToYmd = (dateValue) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const timestampToDateInputValue = (value) => {
  if (value && typeof value.toDate === "function") {
    return formatDateToYmd(value.toDate());
  }
  if (value instanceof Date) {
    return formatDateToYmd(value);
  }
  return "";
};

const isTimestampLike = (value) =>
  Boolean(value) &&
  typeof value === "object" &&
  typeof value.toDate === "function";

const getTimestampMillis = (value) => {
  if (!isTimestampLike(value)) return null;
  const asDate = value.toDate();
  if (!(asDate instanceof Date) || Number.isNaN(asDate.getTime())) return null;
  return asDate.getTime();
};

const areArrayValuesEqual = (left, right) => {
  if (!Array.isArray(left) || !Array.isArray(right)) return false;
  if (left.length !== right.length) return false;
  for (let i = 0; i < left.length; i += 1) {
    if (String(left[i] ?? "") !== String(right[i] ?? "")) return false;
  }
  return true;
};

const areHistoryValuesEqual = (previousValue, nextValue) => {
  const previousIsNullish = previousValue === null || previousValue === undefined;
  const nextIsNullish = nextValue === null || nextValue === undefined;
  if (previousIsNullish && nextIsNullish) return true;

  const previousTs = getTimestampMillis(previousValue);
  const nextTs = getTimestampMillis(nextValue);
  if (previousTs !== null || nextTs !== null) {
    return previousTs === nextTs;
  }

  if (Array.isArray(previousValue) || Array.isArray(nextValue)) {
    return areArrayValuesEqual(previousValue, nextValue);
  }

  return previousValue === nextValue;
};

const cloneHistoryValue = (value) => {
  if (value === undefined) return null;
  if (Array.isArray(value)) return [...value];
  return value;
};

const PRODUCT_HISTORY_TRACKED_FIELDS = [
  "Alias",
  "Articulo",
  "Num_Serie",
  "Categoria",
  "Tipo",
  "Marca",
  "BrandId",
  "CategoryPathIds",
  "Garantia",
  "FechaCompra",
  "ComercioTienda",
  "RazonSocialCli",
  "NumFactura",
  "Factura",
];

const buildProductModificationHistoryEntry = ({
  previousProduct,
  nextProduct,
  editedAtTimestamp,
}) => {
  if (!previousProduct) return null;

  const changeSet = {};

  PRODUCT_HISTORY_TRACKED_FIELDS.forEach((fieldName) => {
    const previousValue = previousProduct?.[fieldName];
    const nextValue = nextProduct?.[fieldName];

    if (areHistoryValuesEqual(previousValue, nextValue)) return;
    changeSet[`${fieldName}_viejo`] = cloneHistoryValue(previousValue);
    changeSet[`${fieldName}_nuevo`] = cloneHistoryValue(nextValue);
  });

  if (!Object.keys(changeSet).length) return null;
  return {
    ...changeSet,
    Fecha: editedAtTimestamp,
  };
};

export const UpsertUsuarioPostventa = async ({ uid, profile = {} }) => {
  if (!uid) throw new Error("UID requerido para actualizar UsuariosPostventa");
  const nameParts = resolveNameParts({
    nombre: profile.Nombre,
    apellido: profile.Apellido,
    titular: profile.Titular,
  });
  const titular = buildFullName({
    nombre: nameParts.nombre,
    apellido: nameParts.apellido,
    fallback: profile.Titular || "",
  });

  const normalized = {
    uid,
    Nombre: nameParts.nombre,
    Apellido: nameParts.apellido,
    Titular: titular,
    Email: profile.Email || "",
    Telefono: profile.Telefono || "",
    CuitDni: profile.CuitDni || "",
    Direccion: profile.Direccion || "",
    Localidad: profile.Localidad || "",
    Provincia: profile.Provincia || "",
    CodigoPostal: profile.CodigoPostal || "",
    updatedAt: serverTimestamp(),
  };

  const refUsuario = doc(db, "UsuariosPostventa", uid);
  await setDoc(refUsuario, normalized, { merge: true });
  return normalized;
};

export const GuardarProductoUsuarioPostventa = async ({
  uid,
  profile = {},
  producto = {},
}) => {
  if (!uid) throw new Error("UID requerido para guardar producto");

  const refUsuario = doc(db, "UsuariosPostventa", uid);
  const snap = await getDoc(refUsuario);
  const prev = snap.exists() ? snap.data() : {};
  const productosPrev = Array.isArray(prev.Productos) ? prev.Productos : [];

  const nowTimestamp = Timestamp.now();
  const productId = producto.id || buildProductId();
  const productIndex = productosPrev.findIndex((p) => p?.id === productId);
  const existing = productIndex >= 0 ? productosPrev[productIndex] : null;
  const enGarantia = Boolean(
    producto?.Garantia ??
    existing?.Garantia
  );
  const normalizedFechaCompra = enGarantia
    ? normalizeFechaCompraToTimestamp(producto?.FechaCompra ?? existing?.FechaCompra)
    : null;

  const productoFinal = {
    ...(existing || {}),
    ...producto,
    id: productId,
    FechaCompra: normalizedFechaCompra,
    createdAt: existing?.createdAt || producto.createdAt || nowTimestamp,
    updatedAt: nowTimestamp,
  };

  const previousHistory = Array.isArray(existing?.HistorialModificaciones)
    ? existing.HistorialModificaciones
    : [];
  const historyEntry = buildProductModificationHistoryEntry({
    previousProduct: existing,
    nextProduct: productoFinal,
    editedAtTimestamp: nowTimestamp,
  });
  const nextHistory = historyEntry ? [...previousHistory, historyEntry] : previousHistory;
  productoFinal.HistorialModificaciones = existing ? nextHistory : [];

  const nextProductos = [...productosPrev];
  if (productIndex >= 0) {
    nextProductos[productIndex] = productoFinal;
  } else {
    nextProductos.unshift(productoFinal);
  }
  const payloadNameParts = resolveNameParts({
    nombre: profile.Nombre ?? prev.Nombre ?? "",
    apellido: profile.Apellido ?? prev.Apellido ?? "",
    titular: profile.Titular ?? prev.Titular ?? "",
  });

  const payload = {
    uid,
    Nombre: payloadNameParts.nombre,
    Apellido: payloadNameParts.apellido,
    Titular:
      buildFullName({
        nombre: payloadNameParts.nombre,
        apellido: payloadNameParts.apellido,
        fallback: profile.Titular ?? prev.Titular ?? "",
      }) || "",
    Email: profile.Email ?? prev.Email ?? "",
    Telefono: profile.Telefono ?? prev.Telefono ?? "",
    CuitDni: profile.CuitDni ?? prev.CuitDni ?? "",
    Direccion: profile.Direccion ?? prev.Direccion ?? "",
    Localidad: profile.Localidad ?? prev.Localidad ?? "",
    Provincia: profile.Provincia ?? prev.Provincia ?? "",
    CodigoPostal: profile.CodigoPostal ?? prev.CodigoPostal ?? "",
    Productos: nextProductos,
    updatedAt: serverTimestamp(),
  };

  await setDoc(refUsuario, payload, { merge: true });
  return productoFinal;
};

export const GetProductosUsuarioPostventa = async (uid) => {
  if (!uid) return [];
  const refUsuario = doc(db, "UsuariosPostventa", uid);
  const snap = await getDoc(refUsuario);
  if (!snap.exists()) return [];
  const data = snap.data();
  const productos = Array.isArray(data.Productos) ? data.Productos : [];
  return productos.map((producto) => ({
    ...producto,
    FechaCompra: timestampToDateInputValue(producto?.FechaCompra),
  }));
};

export const EliminarProductoUsuarioPostventa = async ({ uid, productId }) => {
  if (!uid) throw new Error("UID requerido para eliminar producto");
  if (!productId) throw new Error("ID de producto requerido para eliminar");

  const refUsuario = doc(db, "UsuariosPostventa", uid);
  const snap = await getDoc(refUsuario);
  if (!snap.exists()) return { deleted: false, reason: "user_not_found" };

  const data = snap.data() || {};
  const productos = Array.isArray(data.Productos) ? data.Productos : [];
  const nextProductos = productos.filter((p) => {
    const persistedId = p?.id || `${p?.Num_Serie || "sin-serie"}_${p?.Articulo || "producto"}`;
    return String(persistedId) !== String(productId);
  });

  if (nextProductos.length === productos.length) {
    return { deleted: false, reason: "product_not_found" };
  }

  await setDoc(
    refUsuario,
    {
      Productos: nextProductos,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return { deleted: true };
};
